/**
 * levelBadgeLabel — vertaalt een leerlijncode naar taal die een kind begrijpt.
 *
 * De kaarten toonden de ruwe code ("M6", "E6"). Dat is vaktaal uit de leerlijn
 * — begin, midden of eind van een groep — en het stond juist op het scherm waar
 * een kind een keuze moet maken.
 *
 * De badge is bewust VOORWAARDELIJK: binnen de eigen groep verdwijnt hij. Zou
 * hij altijd staan, dan draagt elke kaart hetzelfde label en onderscheidt het
 * niets. Hij verschijnt alleen bij stof buiten de eigen groep — het enige geval
 * waarin het kind er iets aan heeft.
 */
export function levelBadgeLabel(levelCode: string | undefined, learnerGroup: number): string | null {
  if (!levelCode) return null;

  // Codes hebben de vorm B6 / M6 / E6: letter (begin/midden/eind) + groep.
  const match = /^[BME](\d)$/i.exec(levelCode.trim());
  if (!match) return null;
  const group = Number(match[1]);
  if (!Number.isFinite(group) || group === learnerGroup) return null;
  return `Groep ${group}`;
}